import React from "react";
import { Link } from "react-router-dom";
import "./ListItem.scss";
import TypeButton from "components/TypeButton/TypeButton";
import DateComponent from "components/Date/Date";

import NewSticker from "components/NewSticker/NewSticker";

type Props = {
  type: string;
  title: string;
  id: string;
  date: string;
  isTop: boolean;
  poc: any;
  criteria: string;
};

const ListItem: React.FC<Props> = ({
  type,
  title,
  id,
  date,
  isTop,
  poc,
  criteria,
}) => {
  const date2: any = date.split(" ")[0];

  let isNew = new (Date as any)(date2) > new (Date as any)(criteria);

  return (
    <li>
      <Link
        to={
          process.env.NODE_ENV === "development"
            ? `/?id=${id}`
            : `/board?id=${id}`
        }
      >
        <div className="ListItem">
          <TypeButton type={type}></TypeButton>
          <DateComponent>{date.split(" ")[0]}</DateComponent>
          <p className={`ListItem--title ${isTop ? "strong" : ""}`}>
            {`${
              poc.length > 0
                ? poc.map((item: string) => item).join("")
                : "[전체]"
            } ${title}`}
          </p>
          {isNew && <NewSticker />}
        </div>
      </Link>
    </li>
  );
};

export default React.memo(ListItem);
